import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Zap } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

export function ProductTimesCard({ kitchen }) {
  const productData = (kitchen?.by_product || []).slice(0, 8).map(p => ({
    name: p.product.length > 15 ? p.product.slice(0, 13) + ".." : p.product,
    avg: p.avg_min,
    samples: p.samples,
  }));

  if (productData.length === 0) return null;

  return (
    <Card className="bg-white shadow-sm" data-testid="product-times-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-gray-800">
          <Zap className="w-5 h-5 text-emerald-500" />
          Tempo por Produto
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={productData} layout="vertical" margin={{ left: 80, right: 20, top: 10, bottom: 10 }}>
            <XAxis type="number" tick={{ fontSize: 11, fill: "#6b7280" }} unit="min" axisLine={false} tickLine={false} />
            <YAxis dataKey="name" type="category" tick={{ fontSize: 11, fill: "#374151" }} width={75} axisLine={false} tickLine={false} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 12, border: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
              formatter={(v, name, props) => [`${v} min (${props.payload.samples} amostras)`, "Tempo médio"]}
            />
            <Bar dataKey="avg" name="Tempo médio" radius={[0, 6, 6, 0]} barSize={16}>
              {productData.map((_, i) => (
                <Cell key={i} fill={i < 2 ? "#ef4444" : i < 4 ? "#f59e0b" : "#10b981"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
